import { createAction } from '@ngrx/store';

export const appLaunched = createAction('[App] App Launched');
